"use strict";

var _defineProperty = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var SubModule_1 = require("./SubModule");

var procedures_1 = require("../../procedures");

var types_1 = require("../../types");

var PolymathError_1 = require("../../PolymathError");

var EnableCountTransferManager_1 = require("../../procedures/EnableCountTransferManager");
/**
 * Namespace that handles all Feature related functionality
 */


var Features =
/*#__PURE__*/
function (_SubModule_1$SubModul) {
  _inherits(Features, _SubModule_1$SubModul);

  function Features() {
    var _this;

    _classCallCheck(this, Features);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Features).apply(this, arguments));
    /**
     * List of all existing features
     */

    _this.list = [types_1.Feature.Permissions, types_1.Feature.Tokenholders, types_1.Feature.Dividends, types_1.Feature.TokenholderCountRestrictions, types_1.Feature.PercentageOwnershipRestrictions];
    /**
     * Returns whether a particular feature has been enabled or not
     *
     * @param args.feature - feature for which to query status
     */

    _this.isEnabled = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var feature, contractWrappers, symbol, moduleName, attachedModule;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                feature = args.feature;
                contractWrappers = this.context.contractWrappers, symbol = this.securityToken.symbol;
                moduleName = this.getModuleNameFromFeature(feature);
                _context.next = 5;
                return contractWrappers.getAttachedModules({
                  symbol: symbol,
                  moduleName: moduleName
                }, {
                  unarchived: true
                });

              case 5:
                attachedModule = _context.sent[0];
                return _context.abrupt("return", !!attachedModule);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };
    /**
     * Gets the status on all Security Token features (true = enabled, false = not enabled/disabled)
     */


    _this.getStatus = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this2 = this,
            _result;

        var list, _ref, _ref2, permissionsEnabled, tokenholdersEnabled, dividendsEnabled, countTransferManagerEnabled, percentageTransferManagerEnabled, result;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                list = this.list;
                _context2.next = 3;
                return Promise.all(list.map(function (feature) {
                  return _this2.isEnabled({
                    feature: feature
                  });
                }));

              case 3:
                _ref = _context2.sent;
                _ref2 = _slicedToArray(_ref, 5);
                permissionsEnabled = _ref2[0];
                tokenholdersEnabled = _ref2[1];
                dividendsEnabled = _ref2[2];
                countTransferManagerEnabled = _ref2[3];
                percentageTransferManagerEnabled = _ref2[4];
                result = (_result = {}, _defineProperty(_result, types_1.Feature.Permissions, permissionsEnabled), _defineProperty(_result, types_1.Feature.Tokenholders, tokenholdersEnabled), _defineProperty(_result, types_1.Feature.Dividends, dividendsEnabled), _defineProperty(_result, types_1.Feature.TokenholderCountRestrictions, countTransferManagerEnabled), _defineProperty(_result, types_1.Feature.PercentageOwnershipRestrictions, percentageTransferManagerEnabled), _result);
                return _context2.abrupt("return", result);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    };
    /**
     * Enable a feature
     *
     * @param args.feature - feature to enable
     */


    _this.enable = function (args, opts) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var feature, alreadyEnabled, symbol, procedure;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                feature = args.feature;
                _context3.next = 3;
                return this.isEnabled({
                  feature: feature
                });

              case 3:
                alreadyEnabled = _context3.sent;

                if (!alreadyEnabled) {
                  _context3.next = 6;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.FatalError,
                  message: "Feature '".concat(feature, "' already enabled")
                });

              case 6:
                symbol = this.securityToken.symbol;
                _context3.t0 = feature;
                _context3.next = _context3.t0 === types_1.Feature.Permissions ? 10 : _context3.t0 === types_1.Feature.Tokenholders ? 12 : _context3.t0 === types_1.Feature.Dividends ? 14 : _context3.t0 === types_1.Feature.TokenholderCountRestrictions ? 16 : _context3.t0 === types_1.Feature.PercentageOwnershipRestrictions ? 18 : 20;
                break;

              case 10:
                procedure = new procedures_1.EnableGeneralPermissionManager(Object.assign({
                  symbol: symbol
                }, opts), this.context);
                return _context3.abrupt("break", 21);

              case 12:
                procedure = new procedures_1.EnableGeneralTransferManager(Object.assign({
                  symbol: symbol
                }, opts), this.context);
                return _context3.abrupt("break", 21);

              case 14:
                procedure = new procedures_1.EnableDividendManager(Object.assign({
                  symbol: symbol
                }, opts), this.context);
                return _context3.abrupt("break", 21);

              case 16:
                procedure = new EnableCountTransferManager_1.EnableCountTransferManager(Object.assign({
                  symbol: symbol
                }, opts), this.context);
                return _context3.abrupt("break", 21);

              case 18:
                procedure = new procedures_1.EnablePercentageTransferManager(Object.assign({
                  symbol: symbol
                }, opts), this.context);
                return _context3.abrupt("break", 21);

              case 20:
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.FetcherValidationError,
                  message: "Feature '".concat(feature, "' is not supported")
                });

              case 21:
                return _context3.abrupt("return", procedure.prepare());

              case 22:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    };
    /**
     * Disable a feature
     *
     * @param args.feature - feature to disable
     */


    _this.disable = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var feature, alreadyDisabled, symbol, moduleName, procedure;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                feature = args.feature;
                _context4.next = 3;
                return this.isEnabled({
                  feature: feature
                });

              case 3:
                alreadyDisabled = !_context4.sent;

                if (!alreadyDisabled) {
                  _context4.next = 6;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.FatalError,
                  message: "Feature '".concat(feature, "' already disabled")
                });

              case 6:
                symbol = this.securityToken.symbol;
                moduleName = this.getModuleNameFromFeature(feature);
                procedure = new procedures_1.DisableFeature({
                  symbol: symbol,
                  moduleName: moduleName
                }, this.context);
                return _context4.abrupt("return", procedure.prepare());

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    };

    _this.getModuleNameFromFeature = function (feature) {
      var moduleName;

      switch (feature) {
        case types_1.Feature.Permissions:
          moduleName = contract_wrappers_1.ModuleName.GeneralPermissionManager;
          break;

        case types_1.Feature.Tokenholders:
          moduleName = contract_wrappers_1.ModuleName.GeneralTransferManager;
          break;

        case types_1.Feature.Dividends:
          moduleName = contract_wrappers_1.ModuleName.ERC20DividendCheckpoint;
          break;

        case types_1.Feature.TokenholderCountRestrictions:
          moduleName = contract_wrappers_1.ModuleName.CountTransferManager;
          break;

        case types_1.Feature.PercentageOwnershipRestrictions:
          moduleName = contract_wrappers_1.ModuleName.PercentageTransferManager;
          break;

        default:
          throw new PolymathError_1.PolymathError({
            code: types_1.ErrorCode.FetcherValidationError,
            message: "Feature '".concat(feature, "' is not supported")
          });
      }

      return moduleName;
    };

    return _this;
  }

  return Features;
}(SubModule_1.SubModule);

exports.Features = Features;